// const urlLogin ="http://192.168.11.16:8080/nao-login/user";
const urlLogin ="http://njc.66nao.com/nao-login/user";
export default {
	urlLoginTest:urlLogin,
}    


// WEBPACK FOOTER //
// ./src/scripts/urlLogin.js